<template>
  <div class="case-detail-data-list-gene-preview-display-form-page col-block width-full" :style="{ flex: 1 }">
    <div class="preview-main-container col-block width-full" v-for="(mainFormOption, mfoindex) in mainFormOptions" :key="mfoindex">
      <div class="preview-main-title-container row-block">
        <div class="preview-main-title-block row-block">
          <div class="preview-main-title">{{ mainFormOption.title }}</div>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="preview-category-container col-block width-full">
        <div class="preview-category-block col-block width-full" v-for="(categoryOption, coindex) in previewSelectOptions.categoryOptions" :key="coindex">
          <div v-if="categoryOption.title !== '__DEFAULT'" class="preview-category-title-container row-block">
            <div class="preview-category-title-block row-block">
              <div class="preview-category-title">{{ $t(categoryOption.title) }}</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="preview-category-group-container col-block width-full">
            <div class="preview-category-group-block row-block stretch" v-for="(groupOption, goindex) in categoryOption.groupOptions" :key="goindex">
              <div v-if="groupOption.title !== '__DEFAULT'" class="preview-category-group-cell-container title row-block" :style="{ width: '146px' }">
                <div :style="{ flex: 1 }"></div>
                <div class="preview-category-group-cell-block row-block">
                  <div class="preview-category-group-cell break-line">{{ $t(groupOption.title) }}</div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div class="preview-category-group-cell-container row-block" :style="{ flex: 1 }">
                <div class="preview-category-group-form-list-container row-block flex-start flex-wrap">
                  <div class="preview-category-group-form-container row-block" v-for="(formOption, foindex) in groupOption.options" :key="foindex" :class="{ disabled: selectedMap[mainFormOption.index]['disabled'].includes(formOption.key) }" @click="e => !e.currentTarget.className.split(' ').includes('disabled') && setResultDatas(formOption.key, mainFormOption.index)">
                    <div class="preview-category-group-form-mask"></div>
                    <img :src="selectedMap[mainFormOption.index]['selected'].includes(formOption.key) ? require('../../assets/images/radio-true.svg') : require('../../assets/images/radio-false.svg')">
                    <div class="preview-category-group-form-title">{{ $t(formOption.title) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { reportPreviewOptions } from '../../constants/global/data'
import { groupBy } from '../../constants/global/util'

export default {
  props: {
    defaultDatas: {
      type: Array,
      required: true
    },
    displayType: {
      type: String,
      required: true
    },
    variants: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    selectedMap () {
      return this.mainFormOptions.map(option => {
        let disabledDatas = [...this.defaultDatas]
        let selectedDatas = disabledDatas.splice(option.index, 1)
        return {
          selected: selectedDatas,
          disabled: disabledDatas
        }
      })
    },
    previewSelectOptions () {
      let previewSelectOptions = reportPreviewOptions[this.displayType].filter(option => (
        !option.old &&
        option.displayForm &&
        (option.displayDisplay || (() => true))(this.variants, this.user)
      ))
      previewSelectOptions = {
        options: previewSelectOptions,
        categoryOptions: groupBy(previewSelectOptions, categoryOption => categoryOption.displayCategory || categoryOption.category).map(groupOptions => ({
          title: groupOptions[0].displayCategory || groupOptions[0].category,
          options: groupOptions,
          groupOptions: groupBy(groupOptions, groupOption => groupOption.displayGroup || groupOption.group).map(formOptions => ({
            title: formOptions[0].displayGroup || formOptions[0].group,
            options: formOptions
          }))
        }))
      }
      return previewSelectOptions
    },
    // static
    mainFormOptions () {
      return [
        {
          title: this.$t('COMPONENT.caseDetail.genePreviewDisplayForm.mainFormOptions.title.___1st'),
          index: 0
        },
        {
          title: this.$t('COMPONENT.caseDetail.genePreviewDisplayForm.mainFormOptions.title.___2nd'),
          index: 1
        }
      ]
    }
  },
  methods: {
    setResultDatas (key, index) {
      let resultDatas = [...this.defaultDatas]
      resultDatas[index] = key
      this.$emit('dataUpdate', resultDatas)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/caseDetail/genePreviewDisplayForm.vue